import "../../View/RewardsHomePage/RewardHomePage.css"
import RewardHomeBanner from './RewardHomeBanner'
import WelcomeToworld from './WelcomeToworld'
import RewardsDigitalcards from './RewardsDigitalcards'
import WhatNeooSearchbusiness from './WhatNeooSearchbusiness'
import SeoGeneral from '../BusinessPage/SeoGeneral';

const RewardHomePage = () => {
  const seoMetaData = {
    title: "Neoo Search Business Rewards – Unlock Exclusive Benefits!",
    description: "Discover Neoo Search Business Rewards for Premium Neoo Card members. Earn reward points on every Profile activity and unlock exclusive benefits and offers.",
    ogImage: "https://neoosearch.com/static/media/Admin_chat%20logo.7fa36f039461d205a125.png",
    ogImageAlt: "NeooSearch Rewards Home Page",
    url: process.env.REACT_APP_APPLICATION_URL + "/business-reward-program",
    keywords: "NeooSearch, rewards program, exclusive benefits, earn points, search rewards, customer loyalty, special offers",
    type: "website",
    site_name: "NeooSearch",
    canonical: process.env.REACT_APP_APPLICATION_URL + "/business-reward-program"
  };

  return (
    <>
      <SeoGeneral data={seoMetaData} />
      <div style={{
        padding: '0px'
      }} className='RewardHomePage searchloginmain'>
        <div className='cust_container'>
          <RewardHomeBanner />
          <WelcomeToworld />
          <RewardsDigitalcards />
          <WhatNeooSearchbusiness />
        </div>
      </div>
    </>
  )
}

export default RewardHomePage